(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-bookmark"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // A storefront cannot access browser bookmark APIs. Personalize the manual
    // save instructions without claiming that a bookmark has been created.
    const browserInstructions = () => {
      const ua = navigator.userAgent || '';
      const platform = navigator.userAgentData?.platform || navigator.platform || '';
      const ios = /iPad|iPhone|iPod/i.test(ua)
        || (/Mac/i.test(platform) && navigator.maxTouchPoints > 1);

      if (/FBAN|FBAV|Instagram|; wv\)/i.test(ua)) {
        return 'Open this page in your regular browser using this app\'s menu, then use the browser\'s bookmark or favorites option to save it.';
      }

      if (ios) {
        if (/CriOS/i.test(ua)) {
          return 'In Chrome, tap the More menu (three dots), then Add to Bookmarks.';
        }
        if (/Version\/[\d.]+.*Safari/i.test(ua) && !/FxiOS|EdgiOS|OPiOS/i.test(ua)) {
          return 'In Safari, open the browser\'s Share menu (you may first need to tap More), then choose Add Bookmark and save.';
        }
        return 'Open your browser\'s Share or menu options, then choose Add Bookmark, Add to Bookmarks, or the bookmark star. If this page is inside an app, open it in your regular browser first.';
      }

      if (/Android/i.test(ua)) {
        if (/Chrome/i.test(ua) && !/EdgA|OPR|SamsungBrowser/i.test(ua)) {
          return 'In Chrome, tap the More menu (three dots) beside the address bar, then tap Add to bookmarks (the star).';
        }
        return 'Open your browser\'s menu and choose the bookmark star, Add bookmark, or Add to favorites to save this page.';
      }

      // Do not show a desktop shortcut for unidentified mobile browsers.
      if (/Mobile|Tablet/i.test(ua)) return '';
      if (/Mac/i.test(platform)) {
        return 'Press Command + D to bookmark this page, then confirm in your browser. You can also use the browser\'s Bookmarks or Favorites menu.';
      }
      if (/Win|Linux|CrOS/i.test(platform + ' ' + ua)) {
        return 'Press Ctrl + D to bookmark this page, then confirm in your browser. You can also use the browser\'s Bookmarks or Favorites menu.';
      }
      return '';
    };

    // Delegation also handles sections added or re-rendered in the theme editor.
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.article-bookmark--button');
      if (!button) return;
      const details = button.closest('.article-bookmark--details');
      if (!details || details.dataset.browserInstructions !== 'true') return;
      const help = details.querySelector('[data-bookmark-browser-help]');
      const fallback = details.querySelector('[data-bookmark-fallback-help]');
      if (!help || !fallback) return;
      const instructions = browserInstructions();
      help.textContent = instructions;
      help.hidden = !instructions;
      fallback.hidden = Boolean(instructions);
      // Keep the native details toggle for mouse, touch, and keyboard activation.
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const details = event.target.closest('.article-bookmark--details[open]');
      if (!details) return;
      details.open = false;
      details.querySelector('.article-bookmark--button')?.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
